import { render, staticRenderFns } from "./report-dialog.vue?vue&type=template&id=81c384e4&scoped=true"
import script from "./report-dialog.vue?vue&type=script&lang=js"
export * from "./report-dialog.vue?vue&type=script&lang=js"
import style0 from "./report-dialog.vue?vue&type=style&index=0&id=81c384e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c384e4",
  null
  
)

export default component.exports